import { useRef, useCallback } from "react";

export function useDebouncedCallback(
  callback: (...args: unknown[]) => unknown,
  waitMs: number
): (...args: unknown[]) => void {
  const timeout = useRef<number>();

  return useCallback(
    (...args) => {
      function delayed() {
        clearTimeout(timeout.current);
        callback(...args);
      }

      clearTimeout(timeout.current);
      timeout.current = window.setTimeout(delayed, waitMs);
    },
    [callback, waitMs]
  );
}
